import useAuthRoutes from "./auth/router";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import useReversalRoutes from "./reversal/router";
import useRegisterRoutes from "./registers/router";
import { useTheme } from "../hooks/useTheme";
import React from "react";
import { ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { SnackbarProvider } from "notistack";
import useExternalRoutes from "./external/router";
import { PageTitleProvider } from "../components/PageTitleProvider";
import "dayjs/locale/pt-br";

function RouterComponent() {
  const { colorMode, theme } = useTheme();
  const ColorModeContext = React.createContext({});
  const AuthRoutes = useAuthRoutes();
  const reversal = useReversalRoutes(colorMode);
  const RegisterRoutes = useRegisterRoutes(colorMode);
  const ExternalRoutes = useExternalRoutes({ colorMode });

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
          <SnackbarProvider
            maxSnack={3}
            autoHideDuration={5000}
            anchorOrigin={{ horizontal: "right", vertical: "top" }}
          >
            <Router basename={process.env.REACT_APP_BASE_URL}>
              <PageTitleProvider>
                <Routes>
                  {AuthRoutes.map((item, index) => (
                    <Route
                      key={index}
                      path={item.path}
                      element={item.element}
                    />
                  ))}
                  {reversal.map((item, index) => (
                    <Route
                      key={index}
                      path={item.path}
                      element={item.element}
                    />
                  ))}
                  {RegisterRoutes.map((item, index) => (
                    <Route
                      key={index}
                      path={item?.path}
                      element={item?.element}
                    />
                  ))}
                  {ExternalRoutes.map((item, index) => (
                    <Route
                      key={index}
                      path={item?.path}
                      element={item?.element}
                    />
                  ))}
                </Routes>
              </PageTitleProvider>
            </Router>
          </SnackbarProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default RouterComponent;
